function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { AccessibilityInfo, findNodeHandle, Platform } from "react-native";
import { Gesture, GestureDetector } from "react-native-gesture-handler";
import Animated, { Extrapolate, interpolate, runOnJS, useAnimatedStyle, useSharedValue, withSpring, withTiming } from "react-native-reanimated";
import { useAccessibilityContext } from "./AccessibilityContext";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { View } from "./View";
import { useI18n } from "../lib/i18n";
import { card, Shadow, useTheme } from "../styles";
var BASE_CARD_STYLE = card;
function InternalCard(props) {
    var _props_hideNextButtonIndexes;
    var _useState = _sliced_to_array(useState(0), 2), height = _useState[0], setHeight = _useState[1];
    var a11yRef = useRef(null);
    // Before implementing this we need to re-implement ReviewCompleteCard.onReset to be compatible
    // currently reset changes the CardStack key so we dont know we do need to focus in that scenario
    // const isFirstTimeVisibleRef = useRef(props.index === 0);
    var onHeightRef = useRef(props.onHeight);
    onHeightRef.current = props.onHeight;
    var isInvisible = props.index !== props.animatedIndex.value;
    var translateX = useSharedValue(0);
    var gestureStartX = useSharedValue(0);
    var _useState1 = _sliced_to_array(useState(true), 2), isGestureEnabled = _useState1[0], setIsGestureEnabled = _useState1[1];
    var $t = useI18n().$t;
    var propsNext = props.next;
    var next = useCallback(function() {
        setIsGestureEnabled(false);
        propsNext === null || propsNext === void 0 ? void 0 : propsNext();
    }, [
        propsNext
    ]);
    useEffect(function() {
        if (!isInvisible) {
            translateX.value = 0;
            setIsGestureEnabled(true);
        }
    }, [
        translateX,
        isInvisible
    ]);
    var gesture = Gesture.Pan().enabled(!props.flippable && isGestureEnabled && props._disableGesture !== true).activeOffsetX([
        -10,
        10
    ]).onBegin(function() {
        gestureStartX.value = translateX.value;
    }).onUpdate(function(event) {
        translateX.value = gestureStartX.value + event.translationX;
    }).onEnd(function() {
        var direction = translateX.value >= 0 ? 1 : -1;
        if (next && Math.abs(translateX.value) > 100) {
            translateX.value = withTiming(direction * 400);
            runOnJS(next)();
        } else {
            translateX.value = withSpring(0);
        }
    });
    var animatedIndex = props.animatedIndex, stackHeight = props.stackHeight, index = props.index;
    var fakeCardStyle = useAnimatedStyle(function() {
        return {
            height: stackHeight.value,
            backgroundColor: 'white',
            opacity: stackHeight.value === 0 || stackHeight.value < height ? withTiming(interpolate(animatedIndex.value, [
                index - 3,
                index - 2,
                index - 1,
                index,
                index + 1
            ], [
                0,
                0.9,
                1,
                1,
                0
            ], {
                extrapolateLeft: Extrapolate.CLAMP,
                extrapolateRight: Extrapolate.CLAMP
            })) : withTiming(0),
            transform: [
                {
                    scaleX: withTiming(interpolate(animatedIndex.value, [
                        index - 2,
                        index - 1,
                        index,
                        index + 1
                    ], [
                        0.9,
                        0.95,
                        0,
                        0
                    ], {
                        extrapolateLeft: Extrapolate.CLAMP,
                        extrapolateRight: Extrapolate.CLAMP
                    }))
                },
                {
                    translateY: withTiming(interpolate(animatedIndex.value, [
                        index - 2,
                        index - 1,
                        index,
                        index + 1
                    ], [
                        -20,
                        -10,
                        0,
                        100
                    ], {
                        extrapolateLeft: Extrapolate.CLAMP,
                        extrapolateRight: Extrapolate.CLAMP
                    }))
                },
                {
                    translateX: translateX.value
                }
            ]
        };
    }, [
        height,
        index,
        stackHeight,
        animatedIndex
    ]);
    var style = useAnimatedStyle(function() {
        return {
            opacity: withTiming(interpolate(animatedIndex.value, [
                index - 3,
                index - 2,
                index - 1,
                index,
                index + 1
            ], stackHeight.value === 0 || stackHeight.value < height ? [
                0,
                0,
                0,
                1,
                0
            ] : [
                0,
                0.9,
                1,
                1,
                0
            ], {
                extrapolateLeft: Extrapolate.CLAMP,
                extrapolateRight: Extrapolate.CLAMP
            })),
            transform: [
                {
                    scaleX: withTiming(interpolate(animatedIndex.value, [
                        index - 2,
                        index - 1,
                        index,
                        index + 1
                    ], [
                        0.9,
                        0.95,
                        1,
                        1
                    ], {
                        extrapolateLeft: Extrapolate.CLAMP,
                        extrapolateRight: Extrapolate.CLAMP
                    }))
                },
                {
                    translateY: withTiming(interpolate(animatedIndex.value, [
                        index - 2,
                        index - 1,
                        index,
                        index + 1
                    ], [
                        -20,
                        -10,
                        0,
                        100
                    ], {
                        extrapolateLeft: Extrapolate.CLAMP,
                        extrapolateRight: Extrapolate.CLAMP
                    }))
                },
                {
                    translateX: translateX.value
                }
            ]
        };
    }, [
        height,
        index,
        stackHeight,
        animatedIndex
    ]);
    var isActive = !isInvisible && !props.isInactive;
    useEffect(function() {
        if (height && isActive) {
            var // Set current active height of the card stack
            _onHeightRef_current;
            (_onHeightRef_current = onHeightRef.current) === null || _onHeightRef_current === void 0 ? void 0 : _onHeightRef_current.call(onHeightRef, height);
            // handle a11y focus
            // if (a11yRef.current && !isFirstTimeVisibleRef.current) {
            if (a11yRef.current && Platform.OS !== 'web') {
                var handle = findNodeHandle(a11yRef.current);
                if (handle) {
                    AccessibilityInfo.setAccessibilityFocus(handle);
                }
            }
        // isFirstTimeVisibleRef.current = false;
        }
    }, [
        height,
        isActive
    ]);
    var _props__padding, _props__padding1;
    return /*#__PURE__*/ _jsxs(View, {
        // Previously on Android we were able to forego adding zIndex and maintain proper
        // visual stacking of cards. Recently something changed that forces us to add zIndex.
        // To maintain onPress behavior of child Picker components, we need to expand the View
        // so that the children stay inside of this parent's container. At the same time,
        // we don't want this container to capture pointer events because then cards earlier
        // in the stack that have visually been swiped off will leave their containers behind
        // and we won't be able to press through since the animation happens inside this View.
        style: {
            zIndex: 100 - props.index,
            position: 'absolute',
            width: '100%',
            height: '100%'
        },
        pointerEvents: "box-none",
        children: [
            /*#__PURE__*/ _jsx(Animated.View, {
                "aria-hidden": true,
                pointerEvents: "none",
                style: [
                    BASE_CARD_STYLE,
                    fakeCardStyle,
                    Platform.OS === 'web' ? null : props.index <= props.animatedIndex.value + 2 ? Shadow.high : Shadow.low,
                    {
                        padding: (_props__padding = props._padding) !== null && _props__padding !== void 0 ? _props__padding : 25,
                        position: 'absolute',
                        width: '100%'
                    }
                ]
            }),
            /*#__PURE__*/ _jsx(GestureDetector, {
                gesture: gesture,
                children: /*#__PURE__*/ _jsxs(Animated.View, {
                    onLayout: function(e) {
                        if (height !== e.nativeEvent.layout.height) {
                            setHeight(e.nativeEvent.layout.height);
                        }
                    },
                    style: [
                        BASE_CARD_STYLE,
                        Platform.OS === 'web' ? null : props.index <= props.animatedIndex.value + 2 ? Shadow.high : Shadow.low,
                        {
                            backgroundColor: 'white',
                            padding: (_props__padding1 = props._padding) !== null && _props__padding1 !== void 0 ? _props__padding1 : 25,
                            position: 'absolute',
                            width: '100%',
                            zIndex: 10 - props.index,
                            // same elevation as card, but with a float value added to properly stack
                            elevation: 6 + (100 - props.index) / 10
                        },
                        style
                    ],
                    pointerEvents: isInvisible ? 'none' : undefined,
                    "aria-hidden": isInvisible,
                    testID: isInvisible || props.isInactive ? undefined : 'CardStack_activeCard',
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            ref: a11yRef,
                            accessible: true,
                            "aria-label": props.index === props.count ? $t({
                                id: 'CardStack_endAccessibilityLabel',
                                defaultMessage: 'End of cards'
                            }) : $t({
                                id: 'CardStack_indexAccessibilityLabel',
                                defaultMessage: 'Card {index} of {count}'
                            }, {
                                index: props.index + 1,
                                count: props.count
                            }),
                            role: "heading",
                            // We need an accessible ref to focus on when card becomes active. However, we cannot
                            // use the parent View because on iOS it doesn't allow swiping to focus on children
                            style: {
                                height: 5,
                                width: '100%',
                                marginBottom: -4
                            }
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            spacing: 30,
                            children: [
                                props.header,
                                props.children,
                                props.renderFooter ? props.renderFooter() : props.hideNextButtonIndexes === true || ((_props_hideNextButtonIndexes = props.hideNextButtonIndexes) === null || _props_hideNextButtonIndexes === void 0 ? void 0 : _props_hideNextButtonIndexes.includes(props.index)) ? null : /*#__PURE__*/ _jsx(Button, {
                                    testID: isInvisible ? undefined : 'CardStack_nextButton',
                                    _useGestureHandler: true,
                                    "aria-label": $t({
                                        id: 'CardStack_nextCardAccessibilityLabel',
                                        defaultMessage: 'Next card'
                                    }),
                                    text: $t({
                                        id: 'CardStack_nextButton',
                                        defaultMessage: 'Next'
                                    }),
                                    alignSelf: "center",
                                    onPress: function() {
                                        translateX.value = withTiming(400);
                                        next();
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-29}
 */ export function Card(props) {
    // eslint-disable-next-line
    return /*#__PURE__*/ _jsx(InternalCard, _object_spread({}, props));
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-29}
 */ export function FlippableCard(props) {
    var isScreenReaderEnabled = useAccessibilityContext().isScreenReaderEnabled;
    var height = useSharedValue(0);
    var _useState = _sliced_to_array(useState(false), 2), flipped = _useState[0], setFlipped = _useState[1];
    var rotation = useSharedValue(0);
    var gestureStartRotation = useSharedValue(0);
    var $t = useI18n().$t;
    var gesture = Gesture.Pan().enabled(!flipped && props.backChildren !== null).onBegin(function() {
        gestureStartRotation.value = rotation.value;
    }).onUpdate(function(event) {
        rotation.value = gestureStartRotation.value + event.translationX;
    }).onEnd(function() {
        var direction = rotation.value >= 0 ? 1 : -1;
        var THRESHOLD = 70;
        var adjustedValue = Math.abs(rotation.value);
        if (adjustedValue > THRESHOLD) {
            rotation.value = withTiming(direction * 180);
            runOnJS(setFlipped)(true);
        } else {
            rotation.value = withSpring(0);
            runOnJS(setFlipped)(false);
        }
    });
    var propsOnHeight = props.onHeight;
    var onHeight = useCallback(function(h) {
        height.value = withTiming(h);
        propsOnHeight === null || propsOnHeight === void 0 ? void 0 : propsOnHeight(h);
    }, [
        height,
        propsOnHeight
    ]);
    var style = useAnimatedStyle(function() {
        var zIndex = interpolate(rotation.value, [
            -91,
            -90,
            90,
            91
        ], [
            0,
            1,
            1,
            0
        ], {
            extrapolateLeft: Extrapolate.CLAMP,
            extrapolateRight: Extrapolate.CLAMP
        });
        return {
            zIndex: zIndex,
            elevation: zIndex,
            opacity: zIndex,
            transform: [
                {
                    perspective: 800
                },
                {
                    rotateY: interpolate(rotation.value, [
                        0,
                        180
                    ], [
                        0,
                        180
                    ]) + 'deg'
                }
            ]
        };
    }, [
        flipped
    ]);
    var backStyle = useAnimatedStyle(function() {
        var zIndex = interpolate(rotation.value, [
            -91,
            -90,
            90,
            91
        ], [
            1,
            0,
            0,
            1
        ], {
            extrapolateLeft: Extrapolate.CLAMP,
            extrapolateRight: Extrapolate.CLAMP
        });
        return {
            backfaceVisibility: 'hidden',
            zIndex: zIndex,
            elevation: zIndex,
            opacity: zIndex,
            transform: [
                {
                    perspective: 800
                },
                {
                    rotateY: interpolate(rotation.value, [
                        0,
                        180
                    ], [
                        -180,
                        0
                    ]) + 'deg'
                }
            ]
        };
    }, [
        flipped
    ]);
    var internalProps = props;
    var index = internalProps.index;
    var wrapperStyle = useAnimatedStyle(function() {
        return {
            zIndex: 100 - index,
            position: 'absolute',
            height: height.value,
            width: '100%'
        };
    }, [
        height,
        index
    ]);
    var isInvisible = internalProps.index !== internalProps.animatedIndex.value;
    useEffect(function() {
        // If coming back to a card we want to reset state
        if (!isInvisible) {
            rotation.value = 0;
            setFlipped(false);
            if (height.value) {
                var _props_onHeight;
                (_props_onHeight = props.onHeight) === null || _props_onHeight === void 0 ? void 0 : _props_onHeight.call(props, height.value);
            }
        }
    // eslint-disable-next-line
    }, [
        rotation,
        isInvisible,
        height
    ]);
    return isScreenReaderEnabled ? /*#__PURE__*/ _jsxs(InternalCard, _object_spread_props(_object_spread({}, props), {
        renderFooter: internalProps.next ? undefined : function() {
            return null;
        },
        children: [
            props.frontChildren,
            props.backChildren
        ]
    })) : /*#__PURE__*/ _jsx(GestureDetector, {
        gesture: gesture,
        children: /*#__PURE__*/ _jsxs(Animated.View, {
            pointerEvents: isInvisible ? 'none' : undefined,
            style: wrapperStyle,
            children: [
                flipped ? null : /*#__PURE__*/ _jsx(Animated.View, {
                    style: style,
                    children: /*#__PURE__*/ _jsx(InternalCard, _object_spread_props(_object_spread({}, props), {
                        flippable: !flipped && props.backChildren !== null,
                        renderFooter: props.backChildren === null ? null : function() {
                            return /*#__PURE__*/ _jsx(Button, {
                                testID: isInvisible ? undefined : 'CardStack_flipButton',
                                _useGestureHandler: true,
                                icon: "retry",
                                text: $t({
                                    id: 'CardStack_flippableCard_flipButton',
                                    defaultMessage: 'Flip'
                                }),
                                alignSelf: "center",
                                onPress: function() {
                                    rotation.value = withTiming(180);
                                    setFlipped(true);
                                }
                            });
                        },
                        onHeight: onHeight,
                        children: props.frontChildren
                    }))
                }),
                /*#__PURE__*/ _jsx(Animated.View, {
                    style: backStyle,
                    "aria-hidden": isInvisible || !flipped,
                    pointerEvents: isInvisible || !flipped ? 'none' : undefined,
                    children: /*#__PURE__*/ _jsx(InternalCard, _object_spread_props(_object_spread({}, props), {
                        flippable: !flipped,
                        isInactive: !flipped,
                        onHeight: onHeight,
                        renderFooter: internalProps.next ? undefined : function() {
                            return null;
                        },
                        children: props.backChildren
                    }))
                })
            ]
        })
    });
}
/**
 * A UI component that looks like cards vertically stacked on each other.
 * Exports a parent `CardStack` component which is intended to render  `Card` /
 * `FlippableCard` components as children.
 *
 *
 *
 * Example usage:
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̂̀̀̆́̀̀̆́̀̀̃̄̀̀̃̄̀̀̃̃̀̀̆̄̀̀̃́̀̀̂̍̀̀̆̄̀̀̆̃̀̀̆̆̀̀̃̂̀̀̂̍̀̀̃̄̀̀̃̃̀̀̃̈̀̀̃̄̀̀̂̍̀̀̃̉̀̀̃̄̀̀̆̂̀̀̃̅̀̀̂̍̀̀̃̄̀̀̆̆̀̀̃̂̀̀̃̃̀̀̆̄̀̀̃̉̀̀̃̉̀̀̆̄̀̀̃̆̀̀̆̂̀̀̃̅̀̀̆̄̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃́̀̀̃̂̀̀̃̀̀̀̃̃̀̀̂̍̀̀̃́̀̀̃̉̀̀̃̃̀̀̃̆̀̀̃̃̀̀̃́̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̆̀̀̃̇̀̀̃̂̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̇̀̀̃̀̀̀̃̅̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * **Card Stack**
 *
 * ```typescript
 * type Props = {
 *   &#47;**
 *    * An array of indexes for which to hide the built-in "Next" button to navigate to the next card.
 *    * If true, the button is hidden for all indexes.
 *    *&#47;
 *   hideNextButtonIndexes?: number[] | true;
 *   &#47;**
 *    * A component to render at the top over every card in the stack.
 *    *&#47;
 *   header?: ReactNode;
 *   &#47;**
 *    * The collection of cards to render
 *    *&#47;
 *   children: ReactNode;
 *   &#47;**
 *    * Callback that is executed whenever the card at the top of the stack changes.
 *    *&#47;
 *   &#47;**
 *    * Callback that is executed whenever the card at the top of the stack changes.
 *    *&#47;
 *   onIndexChanged?: (index: number) => void;
 *   &#47;**
 *    * Color for the pagination UI elements below the cards.
 *    *&#47;
 *   pageColor?: string;
 *   &#47;**
 *    * Whether or not to render a final "Completion" card at the bottom of the stack.
 *    *&#47;
 *   hasCompleteCard?: boolean;
 * };
 * ```
 *
 * **Flippable Card**
 *
 * A card that has both a front and back that can be flipped back and forth
 * before navigating to other cards in the stack.
 *
 * ```
 * {
 *   frontChildren?: ReactNode;
 *   backChildren?: ReactNode;
 * }
 * ```
 *
 * **Card**
 *
 * ```
 * {
 *   header?: ReactNode;
 *   children?: ReactNode;
 * }
 * ```
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-29}
 */ export var CardStack = /*#__PURE__*/ forwardRef(function(props, ref) {
    var theme = useTheme().theme;
    var _useState = _sliced_to_array(useState(0), 2), i = _useState[0], setI = _useState[1];
    var iRef = useRef(0);
    iRef.current = i;
    var index = useSharedValue(0);
    var initializedRef = useRef(false);
    var currentHeight = useSharedValue(0);
    var isChangingIndexRef = useRef(false);
    var onIndexChangedRef = useRef(props.onIndexChanged);
    onIndexChangedRef.current = props.onIndexChanged;
    var $t = useI18n().$t;
    var children = Children.toArray(props.children);
    // prefer array length over React.Children.Count b/c of null values
    var count = children.length;
    useEffect(function() {
        if (initializedRef.current) {
            var _onIndexChangedRef_current;
            isChangingIndexRef.current = false;
            onIndexChangedRef === null || onIndexChangedRef === void 0 ? void 0 : (_onIndexChangedRef_current = onIndexChangedRef.current) === null || _onIndexChangedRef_current === void 0 ? void 0 : _onIndexChangedRef_current.call(onIndexChangedRef, i);
        }
    }, [
        i
    ]);
    useEffect(function() {
        if (initializedRef.current) {
            var _onIndexChangedRef_current;
            onIndexChangedRef === null || onIndexChangedRef === void 0 ? void 0 : (_onIndexChangedRef_current = onIndexChangedRef.current) === null || _onIndexChangedRef_current === void 0 ? void 0 : _onIndexChangedRef_current.call(onIndexChangedRef, index.value);
        } else {
            initializedRef.current = true;
        }
    }, [
        index
    ]);
    var setIndex = useCallback(function(v) {
        if (!isChangingIndexRef.current && iRef.current !== v) {
            isChangingIndexRef.current = true;
            index.value = withTiming(v, {}, function() {
                runOnJS(setI)(v);
            });
        }
    }, [
        index
    ]);
    var next = useCallback(function() {
        setIndex(Math.min(count - 1, i + 1));
    }, [
        i,
        count,
        setIndex
    ]);
    var prev = useCallback(function() {
        setIndex(Math.max(0, i - 1));
    }, [
        i,
        setIndex
    ]);
    useEffect(function() {
        if (initializedRef.current && count <= i) {
            setIndex(count - 1);
        }
    }, [
        setIndex,
        i,
        count
    ]);
    useImperativeHandle(ref, function() {
        return {
            prev: prev,
            next: next,
            setIndex: setIndex
        };
    }, [
        prev,
        next,
        setIndex
    ]);
    var pageNavStyle = useAnimatedStyle(function() {
        return {
            alignSelf: 'center',
            marginTop: withTiming(currentHeight.value + 20)
        };
    }, []);
    var _props_pageColor, _props_pageColor1, _props_pageColor2;
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            marginTop: 15
        },
        children: [
            children.map(function(c, j) {
                var _c_props;
                var _c_props_header;
                return /*#__PURE__*/ cloneElement(c, {
                    index: j,
                    count: props.hasCompleteCard ? count - 1 : count,
                    animatedIndex: index,
                    // eslint-disable-next-line
                    header: (_c_props_header = (_c_props = c.props) === null || _c_props === void 0 ? void 0 : _c_props.header) !== null && _c_props_header !== void 0 ? _c_props_header : props.header,
                    hideNextButtonIndexes: props.hideNextButtonIndexes,
                    next: j < count - 1 ? next : undefined,
                    onHeight: function(h) {
                        currentHeight.value = h;
                    },
                    stackHeight: currentHeight
                });
            }),
            props.hasCompleteCard && i === count - 1 ? null : /*#__PURE__*/ _jsx(Animated.View, {
                style: pageNavStyle,
                testID: "CardStack_pagination",
                children: /*#__PURE__*/ _jsxs(View, {
                    row: true,
                    spacing: 24,
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            disabled: i === 0,
                            name: "caret-left",
                            color: (_props_pageColor = props.pageColor) !== null && _props_pageColor !== void 0 ? _props_pageColor : theme.color.gray400,
                            onPress: prev,
                            "aria-label": $t({
                                id: 'CardStack_previousButtonAccessibilityLabel',
                                defaultMessage: 'Previous'
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: $t({
                                id: 'CardStack_progress',
                                defaultMessage: '{index} of {count}'
                            }, {
                                index: i + 1,
                                count: props.hasCompleteCard ? count - 1 : count
                            }),
                            testID: "CardStack_progress_".concat(i + 1, "_of_").concat(props.hasCompleteCard ? count - 1 : count),
                            color: (_props_pageColor1 = props.pageColor) !== null && _props_pageColor1 !== void 0 ? _props_pageColor1 : theme.color.gray200
                        }),
                        /*#__PURE__*/ _jsx(Icon, {
                            disabled: i === count - 1,
                            name: "caret-right",
                            color: (_props_pageColor2 = props.pageColor) !== null && _props_pageColor2 !== void 0 ? _props_pageColor2 : theme.color.gray400,
                            onPress: next,
                            testID: "CardStack_paginationNextButton",
                            "aria-label": $t({
                                id: 'CardStack_nextButtonAccessibilityLabel',
                                defaultMessage: 'Next'
                            })
                        })
                    ]
                })
            })
        ]
    });
});
